export enum ClaimUploadType {
  Files = 'Files',
  ProofOfPayment = 'ProofOfPayment',
}

export default ClaimUploadType;
